// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"bf5368e4","38":"19459721","44":"27a2a589","244":"1bc0839a","340":"dff16524","485":"b8c09105","538":"5326d5d2","615":"d67500b5","768":"0389e2dd"}[chunkId] + ".chunk.js";
};